module.exports = __webpack_public_path__ + "static/media/grc-viedo-preview.683313ba.png";